/* registerIcons.js */

'use strict';
const IconRegistry = require('@gluenetworks/steve_ui_core').IconRegistry;

console.info('ICON REG', IconRegistry);

IconRegistry.registerIcon("wizard.wizardIndicator",require('./rawicons/wizard/wizardIndicator.icon.svg.js'));
